import React, {useState} from 'react'
import {Col, Row} from '../../components/Display'
import FullProblem from './FullProblem'
import services from 'services'
import {useFunction} from 'utils/hooks/function'
import Button from 'components/Button'
import i18n from 'i18n'
import SolutionList from './SolutionList'
import Spinner from 'components/Spinner'
import {Switch, Route, useLocation} from 'react-router-dom'
import SolutionDetails from './SolutionDetails'
import Confirm from 'assets/confirm.svg'
import FullScreen from 'assets/full-screen.svg'
import Archive from 'assets/archive.svg'
import CloseSidePanel from 'assets/close-side-panel.svg'
import Confirmed from 'assets/confirmed.svg'
import {RouteMatch} from 'data/types'

type ProblemContentProps = {
  match: RouteMatch<{problemId: string}>
  deselect: () => void
}

export default function ProblemContent(props: ProblemContentProps) {
  const service = services.getSingleProblemService(props.match.params.problemId)
  const [problem, isLoading] = service.problem.hook()
  const archiveProblem = useFunction(service.archiveProblem)
  const validateProblem = useFunction(service.validateProblem)
  const [isFullScreen, setFullScreen] = useState(false)
  const location = useLocation()
  const isSolutionPage = location.pathname.includes('solutions')

  if (isLoading) {
    return (
      <Col className="flex-1 justify-center items-center">
        <Spinner />
      </Col>
    )
  }

  if (problem == null) {
    return null
  }

  return (
    <Col className="flex-1 overflow-hidden">
      <Row className="flex-shrink-0 flex-grow-0 justify-between bg-white border-b items-center px-4 py-2">
        <Row>
          {!problem.isValidated && (
            <Button
              className="mr-2 bg-itx-primary-4 hover:bg-itx-primary-3 text-white border-none"
              onClick={validateProblem}
              loading={validateProblem.isRunning}
              content={
                <Row>
                  <img className="h-6 w-6 object-cover items-center" src={Confirm} alt={'Confirm'} />
                  <div className="pt-px pl-2 text-white">{i18n.t('problems.confirmButtonText')}</div>
                </Row>
              }
            />
          )}
        </Row>
        <Row>
          {problem.isValidated && (
            <Button
              className="mr border-none hover:bg-white hover:shadow-none pointer-events-none"
              content={
                <Row className="">
                  <img className="h-5 w-5 object-cover items-center" src={Confirmed} alt={'Confirmed'} />
                </Row>
              }
            />
          )}
          {!isSolutionPage && (
            <Button
              className="mr border-none hover:bg-gray-itx-border hover:shadow-none"
              content={
                <Row className="">
                  <img className="h-4 w-4 object-cover items-center" src={FullScreen} alt={'FullScreen'} />
                </Row>
              }
              onClick={() => setFullScreen(true)}
            />
          )}
          <Button
            className="mr border-none hover:bg-gray-itx-border hover:shadow-none"
            loading={archiveProblem.isRunning}
            content={
              <Row className="">
                <img className="h-4 w-4 object-cover items-center" src={Archive} alt={'Archive'} />
              </Row>
            }
            onClick={() => archiveProblem().then(() => props.deselect())}
          />
          <Button
            className="mr border-none hover:bg-gray-itx-border hover:shadow-none"
            content={
              <Row className="">
                <img className="h-4 w-4 object-cover items-center" src={CloseSidePanel} alt={'CloseSidePanel'} />
              </Row>
            }
            onClick={props.deselect}
          />
        </Row>
      </Row>

      <Switch>
        <Route
          exact
          path="/projects/:projectId/problems/:problemId"
          render={(componentProps) => <FullProblem isFullScreen={isFullScreen} setFullScreen={setFullScreen} {...componentProps} />}
        />
        <Route exact path="/projects/:projectId/problems/:problemId/solutions" component={SolutionList} />
        <Route exact path="/projects/:projectId/problems/:problemId/solutions/:solutionId" component={SolutionDetails} />
      </Switch>
    </Col>
  )
}
